import { HardwareType } from './Sundial';
import type { SiteHardware } from './Sundial';

export interface MonitoringAccessRequest {
  monitoringIds: Array<{
    id: string;
    type: HardwareType;
  }>;
}

export interface EquipmentItem {
  manufacturer: string;
  model: string;
  serialNumber: string;
}

export interface EquipmentDetails {
  inverters: EquipmentItem[];
  batteries: EquipmentItem[];
  gateways: EquipmentItem[];
}

export enum MonitoringAccessReason {
  ACCESS_NOT_GRANTED = 'ACCESS_NOT_GRANTED',
  SUNDIAL_TIMEOUT = 'SUNDIAL_TIMEOUT',
  SUNDIAL_UNAVAILABLE = 'SUNDIAL_UNAVAILABLE',
  VALIDATED_NO_EQUIPMENT = 'VALIDATED_NO_EQUIPMENT',
  INVALID_FORMAT = 'INVALID_FORMAT',
  KEYSTONE_UNAVAILABLE = 'KEYSTONE_UNAVAILABLE',
  ALREADY_CONNECTED = 'ALREADY_CONNECTED',
}

export interface MonitoringAccessResult {
  monitoringId: string;
  type: HardwareType;
  verified: boolean;
  siteId?: string;
  equipment?: EquipmentDetails;
  reason?: MonitoringAccessReason;
  reasonDetail?: string;
  readableInverterOrBatteryInfo?: { inverter?: string; battery?: string };
}

export interface MonitoringAccessResponse {
  accountId: string;
  results: MonitoringAccessResult[];
  allVerified: boolean;
}

export interface SundialSystemValidateResponse {
  isAccessible: boolean;
  meterStatus: { type: string; enabled: boolean }[];
  siteHardware?: Omit<SiteHardware, 'siteId'>;
  systemExists: boolean;
}
